

export function createOrder(order) {

    let item = {}

    // number
    item['number'] = order.number

    // isOutstanding
    item['isOutstanding'] = order.status == 'O'

    return item
}